export function getAuthHeaders() {
  const token = localStorage.getItem('auth_token');
  return {
    Authorization: token ? `Token ${token}` : '',
  };
}
